import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }) => {
  commit(types.LIGNE_ROB_COM_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-rob/lignesCom/")
    .then((response) => {
      commit(types.LIGNE_ROB_COM_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_COM_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.LIGNE_ROB_COM_SET_ITEMS, []);
      commit(types.LIGNE_ROB_COM_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_COM_SET_ERROR, e.message);
    });
};
